<template>
	<div class="footer">
		<div class="footer-left">
			<div class="uni-icon uni-icon-mic" @click="startRecognize" v-if="!show"><img class="icon" src="../../static/chat/add.png" /></div>
			<div class="uni-icon uni-icon-mic" @click="onClose" v-else><img class="icon" src="../../static/chat/close.png" /></div>
		</div>
		<div class="footer-center">
			<input class="input-text"  cursor-spacing="20" type="text" v-model="inputValue" @confirm="sendMessge"></input>
		</div>
		<div class="footer-right" @click="sendMessge" v-if="!show">
			<div id='msg-type' >发送</div>
		</div>
		<div class="add_type" v-if="show">
		  <div class="type_list">
		    <div class="type_item" data-type="1" @click="add_text">
		      <div class="type_icon"><img src="../../static/chat/good_5.png"></div>
		      <div class="type_name">图片</div>
		    </div>
            <div class="type_item" data-type="2" @click="onUpload">
		      <div class="type_icon"><img src="../../static/chat/good_5.png"></div>
		      <div class="type_name">文件</div>
		    </div>
		    
		  </div>
		 
		</div>
	</div>
	
</template>

<script>
let inputElement = null;
let inputElement_2 = null;
import { Loading } from "element-ui";
import axios from "axios";
	export default {
        props: ["www","apiurl"],
		name: "chat-input",
		data() {
			return {
				inputValue: '',
				show:false,
				imgUrlJson:[],
                fileJson:[]
				//www:getApp().globalData.www
			}
		},
		methods: {
			startRecognize: function () {
				
				this.show = true
			},
			onClose(){
				this.show = false
			},
			sendMessge: function () {
               
				var that = this;
				if (that.inputValue.trim() == '') {

					that.inputValue = '';
				} else {

					//点击发送按钮时，通知父组件用户输入的内容
					this.$emit('send-message', {
						type: 'text',
						content: that.inputValue
					});
					that.inputValue = '';
					//this.sendmsg()
				}
			},
			add_text(e){
				
				var that = this
				 if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }

        document.body.appendChild(inputElement);
      }
      inputElement.click();
				
				
			},
            uploadFile(el) {
      var _self = this;
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传图片大小不能超过 50MB!");
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$toast("请选择图片文件");
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("msgimg", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl+"/uploadMsgImg", formData, config)
              .then(uploadFileRes => {
             
                var res = uploadFileRes.data
                console.log(res.data);
            
                if (res.status == 1) {
                    that.imgUrlJson.push(res.data);
                
                _self.$emit('send-message', {
                    type: 'img',
                    content: res.data.filepath
                });
                _self.imgUrlJson=[]
                }else{
                    that.$toast(res.msg);
                }
                
                _self.show = false
                inputElement=null
              });
          };
        }
      }
    },

    /* 上传 */
    onUpload() {
      var that = this;
      if (inputElement_2 === null) {
        // 生成文件上传的控件
        inputElement_2 = document.createElement("input");
        inputElement_2.setAttribute("type", "file");
        inputElement_2.style.display = "none";

        if (window.addEventListener) {
          inputElement_2.addEventListener("change", this.uploadFile_2, false);
        } else {
          inputElement_2.attachEvent("onchange", this.uploadFile_2);
        }

        document.body.appendChild(inputElement_2);
      }
      inputElement_2.click();
    },
    uploadFile_2(el) {
      var _self = this;
      var loadingInstance1 = Loading.service({ fullscreen: true });
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传文件大小不能超过 50MB!");
        }
        // else if (files.type.indexOf("image") === -1) {
        //   //如果不是图片格式
        //   // this.$dialog.toast({ mes: '请选择图片文件' });
        //   this.$message.error("请选择图片文件");
        // }
        else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("chatfile", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl + "/uploadChatFile", formData, config)
              .then(uploadFileRes => {
                //console.log(uploadFileRes.data);
                var res = uploadFileRes.data;
                console.log(res.data);
                if (res.status == 1) {
                 
                  that.fileJson.push(res.data);
                
                    _self.$emit('send-message', {
                        type: 'file',
                        content: res.data
                    });
                _self.fileJson=[]
                } else {
                  that.$toast(res.msg);
                }

                that.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance1.close();
                });
                _self.show = false
                inputElement_2 = null;
              });
          };
        }
      }
    },
			async sendmsg(){
				var _self = this
				var parm = {
					
					uid:5,
					recipient_id:3,
					sendmsg:_self.inputValue,
					imgUrlJson:Json.toStringfry(_self.imgUrlJson)
				}
				const res = await this.$myRuquest({
					url: '/sendDialogmsg',
					method: 'GET',
					data: parm
				})
				
				console.log(res)
			}
		}
	}
</script>

<style scoped>
	@import "../../common/icon.css";

	.footer {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		border-top: solid 0px #bbb;
		overflow: hidden;
		padding: 0.1rem;
		background-color: #fafafa;
		flex-wrap: wrap;
	}
	.footer-left {

		width: 0.8rem;
		height: 0.8rem;
		display: flex;
		justify-content: center;
		align-items: center;
		
		
		
	}
	.icon{
		width:0.4rem;
		height: 0.4rem;
	}
	.footer-right {
		margin-top:0.08rem;
		width: 1.2rem;
		height: 0.64rem;
		display: flex;
		border-radius: 0.12rem;
		justify-content: center;
		align-items: center;
		color: #fff;
		background-color: #1395ff;
        font-size: 0.14rem;
        
	}
     @media (max-width: 991px) {
         .footer-right {
             font-size:0.28rem;
         }
         }
	.footer-center {
		flex: 1;
		height: 0.8rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right:0.2rem;
	}
	.footer-center .input-text {
		flex: 1;
		background: #fff;
		border: solid 0.01rem #ddd;
		padding: 0.1rem!important;
		font-family: verdana !important;
		overflow: hidden;
		border-radius: 0.15rem;
        height: 0.64rem;
	}
	.add_type {
	  width: 7.5rem;
	  height: 3rem;
	  background: #ffffff;
	  position: relative;
	}
	.add_type .type_list {
	  padding: 0.64rem 0.38rem;
	  display: flex;
	  justify-content: space-around;
	  width:6.78rem;
	}
	.add_type .type_list .type_item {
	  width: 1rem;
	  text-align: center;
	  flex-direction: column;
	  align-items: center;
	}
	.add_type .type_list .type_item .type_icon {
	  width: 1rem;
	  height: 1rem;
	  margin-bottom: 0.28rem;
	}
	.add_type .type_list .type_item .type_icon img {
	  width: 100%;
	  height: 100%;
	}
	.add_type .type_list .type_item .type_name {
	  font-size: 0.2rem;
	  color: #999999;
	  line-height: 0.3rem;
      
	}
    @media (max-width: 991px) {
        .add_type .type_list .type_item {
	  width: 1.4rem;
	  text-align: center;
	  flex-direction: column;
	  align-items: center;
	}
        .add_type .type_list .type_item .type_icon {
	  width: 1.4rem;
	  height: 1.4rem;
	  margin-bottom: 0.28rem;
	}
        .add_type .type_list .type_item .type_name {
	  font-size: 0.28rem;
	  color: #999999;
	  line-height: 0.36rem;
      
	}
    }
	.add_type .add_btn {
	  position: absolute;
	  left: 0;
	  bottom: 0;
	  width: 100%;
	  height: 1rem;
	  line-height: 1rem;
	  background: #f7f7f7;
	  font-size: 0.3rem;
	
	  color: #666666;
	  text-align: center;
	  align-items: center;
	  justify-content: center;
	}

</style>



// WEBPACK FOOTER //
// src/components/chatinput.vue